import React, { useMemo } from 'react'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap'
import { rj, useRj, useRunRj } from 'react-rocketjump'
import { ajax } from 'rxjs/ajax'
import moment from 'moment'

const ModalRimanenze = ({ ordine, isOpen, toggle, runAvanzamentiCommesse, filtersToUse }) => {
  const RimanenzeState = rj(() =>
    ajax.getJSON(
      `/api/planner/ordini/${ordine.id}/rimanenze-attivita-operatore`
    )
  )

  const RimanenzeStateFiltered = rj(() =>
    ajax.getJSON(
      `/api/planner/ordini/${ordine.id}/rimanenze-attivita-operatore-filtered?data_inizio=${filtersToUse.from_date}&data_fine=${filtersToUse.to_date}`
    )
  )

  const CompletateRimanenzeState = rj(() =>
    ajax.getJSON(`/api/planner/ordini/${ordine.id}/completa-attivita-operatore`)
  )

  const CompletaSingolaLavorazioneState = rj((ordineId, lavorazione) =>
    ajax.getJSON(
      `/api/planner/ordini/${ordine.id}/completa-singola-lavorazione/?${new URLSearchParams({
        lavorazione,
      }).toString()}`
    )
  )

  const [{ data: rimanenze, loading }, {
    run: runRimanenze
  }] = useRunRj(RimanenzeState)

  const [{}, { run: runCompletateRimanenze }] = useRj(
    CompletateRimanenzeState,
    { initialData: {} }
  )

  const [{}, { run: runCompletaSingolaLavorazione }] = useRj(
    CompletaSingolaLavorazioneState,
    { initialData: {} }
    
  )

  const [{ data: rimanenzeFiltered }, {
    run: runRimanenzeFiltered
  }] = useRunRj(
    RimanenzeStateFiltered,
  )

  const thColumnsPostazioni = useMemo(() => {
    if (!rimanenze || !rimanenzeFiltered) {
      return []
    }
    return Object.keys(rimanenze).map((config) => ({
      Header: config,
      accessor: config,
    }))
  }, [rimanenze, rimanenzeFiltered])

  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [setIsSubmittingSingle, setSetIsSubmittingSingle] = React.useState(false)

  return (
    <Modal isOpen={isOpen !== null} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Ordine attività rimanenze - {ordine?.ordine_data?.numero_commessa} -{' '}
        {ordine?.ordine_data?.cliente?.nome}
      </ModalHeader>
      <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {loading && <Spinner />}
        {!loading && (
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Postazione</th>
                <th>Rimanenze nel periodo  <br />
                  <small>
                    {moment(filtersToUse.from_date).format('DD/MM/YYYY')} -{' '}
                    {moment(filtersToUse.to_date).format('DD/MM/YYYY')}
                  </small>
                </th>
                <th>Rimanenze</th>
              </tr>
            </thead>
            <tbody>
              {thColumnsPostazioni.map((th) => (
                <tr key={th.accessor}>
                  <td>
                    <strong>{th.Header}</strong>
                  </td>
                  <td className='text-nowrap'>
                    {Object.values(
                      rimanenzeFiltered[th.accessor]?.lavorazioni_pezzi
                    )?.map((item, index) => {
                      return (
                        <div key={index} className="d-flex align-items-center mb-2">
                          <div className="mt-1 mr-1"
                            style={{
                              color:
                                item.pezzi_eseguiti === item.pezzi_totali
                                  ? 'darkgreen'
                                  : 'red',
                            }}
                          >
                            {item.lavorazione}: {item.pezzi_totali - item.pezzi_eseguiti} /{' '}
                            {item.pezzi_totali}
                          </div>
                        </div>
                      )
                    })}
                  </td>
                  <td className='text-nowrap'>
                    {Object.values(
                      rimanenze[th.accessor]?.lavorazioni_pezzi
                    )?.map((item, index) => {
                      return (
                        <div key={index} className="d-flex align-items-center pb-2">
                          <div
                            className="mr-3"
                            style={{
                              color:
                                item.pezzi_eseguiti === item.pezzi_totali
                                  ? 'darkgreen'
                                  : 'red',
                            }}
                          >
                            {item.lavorazione}:{' '}
                            {item.pezzi_totali - item.pezzi_eseguiti} /{' '}
                            {item.pezzi_totali}
                          </div>
                          {/* button for completare if pezzi_eseguiti < pezzi_totali */}
                          {item.pezzi_eseguiti < item.pezzi_totali && (
                            <Button
                              color="primary"
                              size="sm"
                              outline
                              disabled={setIsSubmittingSingle}
                              style={{ padding: '0.2rem 0.5rem' }}
                              className="ml-4"
                              onClick={() => {
                                setSetIsSubmittingSingle(true)
                                runCompletaSingolaLavorazione
                                  .onSuccess(() => {
                                    runRimanenzeFiltered({
                                      data_inizio: filtersToUse.from_date,
                                      data_fine: filtersToUse.to_date,
                                    })
                                    runRimanenze()
                                    runAvanzamentiCommesse({...filtersToUse })
                                    setSetIsSubmittingSingle(false)
                                  })
                                  .run(ordine.id, item.lavorazione)
                              }}
                            >
                              {setIsSubmittingSingle && <Spinner size="sm" className="mr-1" />}
                              Completa
                            </Button>
                          )}
                        </div>
                      )
                    })}
                    <br />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        <Button color="secondary" onClick={toggle}>
          Chiudi
        </Button>
        <Button
            disabled={isSubmitting}
          color="primary"
          onClick={() => {
            setIsSubmitting(true)
            runCompletateRimanenze
              .onSuccess(() => {
                setIsSubmitting(false)
                toggle()
                runAvanzamentiCommesse({...filtersToUse })
              })
              .run(ordine.id)
          }}
        >
            {isSubmitting && <Spinner size="sm" className="mr-1" />}
          Completa attività
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalRimanenze
